import { MessageBar, MessageBarType, useTheme } from '@fluentui/react';
import { useConfigValuesState } from '../../../../../hooks/useConfigValue';
import { Link } from 'react-router-dom';

export const PercentageInputTypeDisclaimer = () => {
    const {
        initialData: {
            configuration: { gridInputType },
        },
    } = useConfigValuesState();
    const isPercentInputType = gridInputType === 'percent';
    const theme = useTheme();

    return (
        <>
            {isPercentInputType && (
                <MessageBar
                    messageBarType={MessageBarType.warning}
                    styles={{
                        root: {
                            color: theme.semanticColors.bodyText,
                        },
                    }}
                >
                    Percentage input requires the user's capacity to be set to Default or above 0. Update it
                    <Link to="/admin/resource-overview" style={{ color: theme.semanticColors.bodyText }}>
                        here.
                    </Link>
                </MessageBar>
            )}
        </>
    );
};
